import { Directive, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TimeZones } from 'generated/graphql-types';
import { ExtensionDetailView } from './extension-detail-view.model';

@Directive()
export abstract class ExtensionTypeDetails {
   @Input() parentFormGroup: UntypedFormGroup;

   @Input() isSystemUser: boolean;

   @Input() extension: ExtensionDetailView | null;

   @Input() showCards: boolean = true;

   @Input() timeZoneId: TimeZones | null;
}
